import React from 'react';
import resources from '../../resources';
import languages from '../../appdata/languages';
import StoreManager from '../../appdata';

class VNGsApproachToCSRContent extends React.Component {
  render() {
    const lg = StoreManager.appState.thisApp.state.currentLanguage;
    const text = languages[lg].VNGsApproachToCSRContent; // có thể dùng dynamic switch
    const { isMobile } = StoreManager.appState.thisApp.state

    return (
      <div>
        <h2 style={{  fontFamily: 'Inter28-SemiBold', fontSize: isMobile ? 24 : 36, fontWeight: 600 }}>{text.heading}</h2>
        <p style={{ marginTop: 16 }}>{text.intro}</p>

        <h4 style={{ fontWeight: 600, fontSize: 16, marginTop: 32, fontFamily: 'Inter28-SemiBold' }}>{text.meaningfulProductsTitle}</h4>
        <div style={{ backgroundColor: '#EDF8FF', borderRadius: 16, padding: 24 }}>

          <ul style={{ paddingLeft: 20 }}>{text.meaningfulProducts.map((item, idx) => <li key={idx}>{item}</li>)}</ul>
        </div>
        <div style={{ display: 'flex', gap: 16, marginTop: 24 }}>
          <img src={resources.images.VNGsApproachToCSRImage1} style={{ width: '60%', borderRadius: 8 }} />
          <img src={resources.images.VNGsApproachToCSRImage2} style={{ width: '34%', borderRadius: 8 }} />
        </div>
        <div style={{ display: 'flex', gap: 16, marginTop: 16 }}>
          <img src={resources.images.VNGsApproachToCSRImage3} style={{ width: '50%', borderRadius: 8 }} />
          <img src={resources.images.VNGsApproachToCSRImage4} style={{ width: '50%', borderRadius: 8 }} />
        </div>

        {/* <h4 style={{ fontWeight: 600, fontSize: 16, marginTop: 32 }}>{text.solutionsTitle}</h4> */}
        <p style={{ marginTop: 32 }}>{text.solutionsIntro}</p>
        <div style={{ backgroundColor: '#EDF8FF', borderRadius: 16, padding: 24 }}>

          <ul style={{ paddingLeft: 20 }}>{text.solutions.map((item, idx) => <li key={idx}>{item}</li>)}</ul>
        </div>
        <div style={{ marginTop: 48 }}>
          <img src={lg == 'vi' ? resources.images.VNGsApproachToCSRImage5_vi : resources.images.VNGsApproachToCSRImage5} style={{ width: '100%', borderRadius: 16, marginBottom: 24 }} />
          {
            isMobile ? <></> :  <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            <img src={resources.images.VNGsApproachToCSRImage6} style={{ flex: 1, minWidth: 240, maxWidth: '50%', borderRadius: 16 }} />
            <img src={resources.images.VNGsApproachToCSRImage7} style={{ flex: 1, minWidth: 240, maxWidth: '50%', borderRadius: 16 }} />
          </div>
          }
         
          <div style={{ marginTop: 24 }}>{text.zaloSupport.map((p, idx) => <p key={idx}>{p}</p>)}</div>
        </div>

        <div style={{ marginTop: 48 }}>
          <img src={lg == 'vi' ? resources.images.VNGsApproachToCSRImage8_vi : resources.images.VNGsApproachToCSRImage8} style={{ width: '100%', borderRadius: 16, marginBottom: 32 }} />
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{text.impactTitle}</h4>
          {text.impact.map((p, idx) => <p key={idx}>{p}</p>)}
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 24 }}>
            <img src={resources.images.VNGsApproachToCSRImage9} style={{ flex: 1, minWidth: 240, maxWidth: isMobile? '100%':'65%', borderRadius: 16 }} />
            {
              isMobile? <></> :  <img src={resources.images.VNGsApproachToCSRImage10} style={{ flex: 1, minWidth: 240, maxWidth: '35%', borderRadius: 16 }} />

            }
          </div>
        </div>

        <div style={{ marginTop: 48 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{text.empowerTitle}</h4>
          {/* <p>{text.empowerIntro}</p> */}
          <div style={{ backgroundColor: '#EDF8FF', borderRadius: 16, padding: 24 }}>

            <ul style={{ paddingLeft: 20 }}>{text.empowerList.map((li, idx) => <li key={idx}>{li}</li>)}</ul>
          </div>
          <p>{text.empowerSummary}</p>
          <img src={lg == 'vi' ? resources.images.VNGsApproachToCSRImage11_vi : resources.images.VNGsApproachToCSRImage11} style={{ width: '100%', borderRadius: 16, marginTop: 24 }} />
        </div>

        <div style={{ marginTop: 32 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{text.highlightTitle}</h4>
          <p style={{ fontWeight: 600, marginTop: 16, fontFamily: 'Inter28-SemiBold' }}>{text.educationTitle}</p>
          {/* <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          {text.educationItems.slice(0, 2).map((txt, idx) => (
            <p key={idx} style={{ backgroundColor: '#EDF8FF', borderRadius: 12, padding: 16, flex: 1, maxWidth: '48%' }}>{txt}</p>
          ))}
        </div> */}
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            {text.educationItems.slice(0, 2).map((txt, idx) => {
              const match = txt.match(/^(\d+)\s+(.*)/); // bắt số đầu tiên
              return (
                <div
                  key={idx}
                  style={{
                    backgroundColor: '#EDF8FF',
                    borderRadius: 12,
                    padding: 16,
                    flex: 1,
                    maxWidth: '48%',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {match ? (
                    <p style={{ margin: 0, fontFamily: 'Inter28-SemiBold', textAlign: 'left' }}>
                      <span style={{ fontSize: 36, fontWeight: 600, color: '#F15A24' }}>
                        {match[1]}
                      </span>{' '}
                      {match[2]}
                    </p>
                  ) : (
                    <p style={{ margin: 0 }}>{txt}</p>
                  )}
                </div>
              );
            })}
          </div>


          {/* {text.educationItems.slice(2).map((txt, idx) => (
                  <p key={idx} style={{ backgroundColor: '#EDF8FF', borderRadius: 12, padding: 16, marginTop: 16 }}>{txt}</p>
                ))} */}

          <div style={{ marginTop: 16, fontFamily: 'Inter28-SemiBold' }}>
            {text.educationItems.slice(2).map((txt, idx) => {
              const parts = txt.split(/(\d+)/);
              return (
                <div
                  key={idx}
                  style={{
                    backgroundColor: '#EDF8FF',
                    borderRadius: 12,
                    padding: 16,
                    marginTop: 16,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <p style={{ margin: 0 }}>
                    {parts.map((part, index) => (
                      /^\d+$/.test(part) ? (
                        <span key={index} style={{ fontSize: 36, fontWeight: 600, color: '#F15A24' }}>
                          {part}
                        </span>
                      ) : (
                        <span key={index}>{part}</span>
                      )
                    ))}
                  </p>
                </div>
              );
            })}
          </div>


          <p style={{ fontWeight: 600, marginTop: 24, fontFamily: 'Inter28-SemiBold' }}>{text.welfareTitle}</p>
          <div
            style={{
              display: 'flex',
              gap: 8,
              flexWrap: 'wrap',
              fontFamily: 'Inter28-SemiBold',
            }}
          >
            {text.welfareItems.map((item, idx) => (
              <div
                key={idx}
                style={{
                  backgroundColor: '#F1F8FF',
                  borderRadius: 16,
                  padding: '12px 24px',
                  flex: 1,
                  maxWidth: '32%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                {item.label === 'Supported' || item.label === 'Hỗ trợ' ? (
                  <>
                    <p
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        margin: 0,
                        textAlign: 'left',
                        color: '#000',
                      }}
                    >
                      {item.label}
                    </p>
                    <p
                      style={{
                        fontSize: 36,
                        fontWeight: 600,
                        color: '#F15A24',
                        margin: '4px 0',
                        textAlign: 'left',
                      }}
                    >
                      {item.value}
                    </p>
                    <p style={{ margin: 0, fontSize: 14, textAlign: 'left' }}>
                      {item.suffix}
                    </p>
                  </>
                ) : (
                  <>
                    <p
                      style={{
                        fontSize: 36,
                        fontWeight: 600,
                        color: '#F15A24',
                        margin: '0 0 8px 0',
                        textAlign: 'left',
                      }}
                    >
                      {item.value}
                    </p>
                    <p style={{ fontSize: 14, margin: 0, textAlign: 'left' }}>
                      {item.label}
                    </p>
                  </>
                )}
              </div>
            ))}
          </div>

        </div>
      </div>
    );
  }
};

export default VNGsApproachToCSRContent;